export const TRACE_STORAGE_KEY = 'magic-circle.calibration-traces.v1'
const TRACE_LIMIT = 40

const roundedPoints = (points = []) => points.map(({ x, y }) => ({
  x: Math.round(Number(x) * 100) / 100,
  y: Math.round(Number(y) * 100) / 100,
}))

export function createTraceRecord({
  id = `trace-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  recordedAt = new Date().toISOString(),
  build = 'unknown',
  mode = 'unknown',
  outcome = 'unknown',
  viewport = {},
  raw = [],
  outer = [],
  bridge = [],
  central = [],
  evaluation = null,
  classification = null,
  reason = null,
} = {}) {
  return {
    schemaVersion: 1,
    privacy: 'local-only',
    id,
    recordedAt,
    build,
    mode,
    outcome,
    viewport: {
      width: Number(viewport.width) || 0,
      height: Number(viewport.height) || 0,
    },
    raw: roundedPoints(raw),
    segments: {
      outer: roundedPoints(outer),
      bridge: roundedPoints(bridge),
      central: roundedPoints(central),
    },
    evaluation: evaluation ? structuredClone(evaluation) : null,
    classification: classification ? structuredClone(classification) : null,
    reason,
  }
}

export function readTraceRecords(storage) {
  try {
    const parsed = JSON.parse(storage?.getItem(TRACE_STORAGE_KEY) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export function saveTraceRecord(storage, record, limit = TRACE_LIMIT) {
  const records = [...readTraceRecords(storage), record].slice(-limit)
  storage?.setItem(TRACE_STORAGE_KEY, JSON.stringify(records))
  return records
}

export function clearTraceRecords(storage) {
  storage?.removeItem(TRACE_STORAGE_KEY)
}
